var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.data,"size":"middle","pagination":_vm.pagination,"rowClassName":_vm.classFun,"loading":_vm.loading},on:{"change":_vm.tableChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }